import React, { useEffect, useState } from 'react';
import {
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Card,
  Col,
  Row,
  Button,
} from 'reactstrap';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import Api from '../../util/api';
import t, { partial } from '../../util/translation/translation';
import useModal from '../../shared/hooks/useModal';
import DeleteModal from '../../shared/components/custom/DeleteModal';
import Loading from '../../shared/components/custom/Loading';

const CommunicationApiPage = () => {
  const [loading, setLoading] = useState(false);
  const [apiAccessList, setApiAccessList] = useState([]);
  const [handleModal, visible, deleteID] = useModal();
  const s = partial('shared');

  const getApiAccess = async () => {
    setLoading(true);
    try {
      const accessList = await Api.userDevices.getApiAccesses();
      setApiAccessList(accessList);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(t('api.404'));
    }
  };
  useEffect(() => {
    getApiAccess();
  }, []);
  const renderApiKeys = () => {
    return apiAccessList?.map((access) => {
      return (
        <tr key={`apiAccess-${access.id}`} className="center-list">
          {/*<td>
            <Link to={{ pathname: `/messages_api/show/${access.id}` }}>
              {s('show')}
            </Link>
          </td>*/}
          <td>{access.apiKey}</td>
          <td>{access.entityName}</td>
          <td>{access.requestsCount}</td>
          <td>
            <UncontrolledDropdown className="dashboard__table-more">
              <DropdownToggle>
                <DotsHorizontalIcon />
              </DropdownToggle>
              <DropdownMenu className="dropdown__menu">
                <DropdownItem
                  onClick={() => handleModal(access.id)}
                  className="danger"
                >
                  {s('delete')}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </td>
        </tr>
      );
    });
  };
  const deleteApiAccess = async () => {
    setLoading(true);
    try {
      await Api.userDevices.deleteApiAccess(deleteID);
      toast.success(s('deleteSuccessful'));
    } catch (err) {
      toast.error(t('api.404'));
    } finally {
      handleModal();
      getApiAccess();
    }
  };
  return (
    <Container className="form d-flex">
      <Loading loading={loading} />
      <DeleteModal
        visible={visible}
        type={s('access')}
        handleModal={handleModal}
        modalAction={deleteApiAccess}
      />
      <Card>
        <Col>
          <Row>
            <h3 className="page-title mb-0">API</h3>
            <Link
              to={{ pathname: '/messages_api/create' }}
              style={{ marginLeft: 'auto' }}
            >
              <Button color="primary" size="sm">
                {s('create')} {s('key')}
              </Button>
            </Link>
          </Row>
        </Col>
        <div
          className="mt-4"
          style={{
            display: 'flex',
            paddingBottom: 5,
            marginTop: 5,
            background: '#fff',
            borderRadius: 6,
            border: '1px solid rgba(0,0,0,0.08)',
          }}
        >
          <Table responsive striped>
            <thead>
              <tr>
                <th>
                  <div className="flex alignItems-center">{s('key')}</div>
                </th>
                <th>
                  <div className="flex alignItems-center">
                    {s('companyName')}
                  </div>
                </th>
                <th>
                  <div className="flex alignItems-center">{s('usage')}</div>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>{renderApiKeys()}</tbody>
          </Table>
        </div>
      </Card>
    </Container>
  );
};

export default CommunicationApiPage;
